import { deleteSupplierItem } from '../../../HttpRequests/supplierItems';
import { setSubmitting } from '../State/submitting';
import handleException from '../../../Core/Helpers/handleException';
import { message, Modal } from 'antd';
import { getProps } from '../props';

const { confirm } = Modal;

export default () => async (dispatch, getState) => {

  const { onClose, didDelete } = getProps();
  const { supplierItem } = getState().modals.SupplierItem;

  if (!supplierItem) return;

  confirm({
    title: 'Are you sure you want to delete this catalog item?',
    content: 'This action cannot be undone.',
    okText: 'Yes, delete',
    okType: 'danger',
    cancelText: 'Cancel',
    onOk: async () => {
      try {
        dispatch(setSubmitting(true));
        await deleteSupplierItem({ id: supplierItem.id });
        message.success('Catalog item deleted successfully');
        if (didDelete) didDelete();
        if (onClose) onClose();
      } catch (error) {
        handleException(error);
      } finally {
        dispatch(setSubmitting(false));
      }
    },
  });
}
